export default ["M7.2 1.428A4 4 0 005 5v2H4a1 1 0 000 2h1v1.5c0 1.133-.229 1.79-.457 2.133-.21.315-.413.367-.543.367H3v2h10v-2H6.591c.27-.684.409-1.522.409-2.5V9h3a1 1 0 100-2H7V5a2 2 0 013.732-1l1.732-1a4 4 0 00-4.666-1.815"];
